import {Inject, Injectable, InjectionToken, NgZone} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, BehaviorSubject, of, interval} from 'rxjs';
import {GdkConfigUrl, GdkLogin, GdkReqDataSql, GdkReqDataSqlResult, GdkReqReport} from '../types';
import {Platform} from '@angular/cdk/platform';
import {Router} from '@angular/router';
import {GdkCrypto} from '../utils/gdk-crypto';
import {map} from 'rxjs/operators';
import {GdkAlertService} from './gdk-alert.service';
import {GdkInfoPage} from '../utils/gdk-info-page';
import {GdkLogoutService} from './logout.service';
import {GdkUtils} from '../utils';
import {GdkNavigationService} from './navigation.service';
import {TranslateService} from '@ngx-translate/core';

export const gdk_CONFIG_URL = new InjectionToken<GdkConfigUrl>('gdkHttpClientConfig');

@Injectable({
  providedIn: 'root'
})
export class GdkHttpClientService {
  // Public
  public config: GdkConfigUrl;
  private socket;


  constructor(private _platform: Platform,
              private _router: Router,
              @Inject(gdk_CONFIG_URL) private _config: GdkConfigUrl,
              private httpclient: HttpClient,
              private gdkAlert: GdkAlertService,
              private  _gdkNav: GdkNavigationService,
              private zone: NgZone,
              private  gdkLogout: GdkLogoutService,
              public  translate: TranslateService
  ) {
    this.config = _config;

  }

  uploadData(fileUpload: File, ishowLoadding: true | false = false): Observable<any> {
    if (ishowLoadding) {
      this.gdkAlert.loading(true, 1);
    }

    let headers = new HttpHeaders({'Content-Type': 'multipart/form-data'});
    const _token = GdkInfoPage.getToken();
    headers = new HttpHeaders({
        'token': _token
      }
    );
    if (!_token) {
      return of({ok: false, msg: 'Khá»i táº¡o khÃ´ng thÃ nh cÃ´ng!'});
    }
    const fd = new FormData();
    fd.append('file', fileUpload, fileUpload.name);
    // Náº¿u nhiá»u file fileUpload: File[];
    // fileUpload.forEach(f=> {
    //   fd.append('file', f, f.path);
    // });

    return Observable.create(obs => {
      this.httpclient.post<any>(this.config.urlBaseServer + '/uploads', fd, {
          headers: headers
        }
      ).pipe(map(m => {
          const noidungrp = GdkCrypto.decryptAES(m.data);
          const noidungJson = JSON.parse(noidungrp);
          if (ishowLoadding) {
            this.gdkAlert.loading(false);
          }
          return noidungJson;
        }
      )).subscribe(s => {
          obs.next(s);
          obs.complete();
          if (ishowLoadding) {
            this.gdkAlert.loading(false);
          }
        }, err => {
          obs.error(err);
          obs.complete();
          if (ishowLoadding) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  thuc_thi(ten: string, callback: (d: string) => void): void {
    if (!localStorage.getItem(ten)) {
      localStorage.setItem(ten, '1');
      return;
    }
    this.gdkAlert.loading(true);
    callback(ten);
  }

  reset_kiem_tra(ten: string): void {
    localStorage.removeItem(ten);
  }


  queryData(data: GdkReqDataSql, typeAlert: true | false = false): Observable<GdkReqDataSqlResult | any> {


    if (typeAlert) {
      this.gdkAlert.loading(true, 1);
    }
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    const _token = GdkInfoPage.getToken();
    if (_token) {
      headers = headers.append('token', _token);
      // headers = new HttpHeaders( {
      //     'Content-Type': 'application/json',
      //     'token': _token
      //      }
      // );
    } else {
      return of({ok: false, msg: 'Khá»i táº¡o khÃ´ng thÃ nh cÃ´ng!'});
    }

    // console.log('req', data);
    data = GdkUtils.parms_Convert_mongodb(data, this.translate.getDefaultLang());
    console.log('JSON.stringify(data)', JSON.stringify(data));
    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>
      (
        this.config.urlBaseServer + '/query',
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'}
      ).pipe(map(
        m => {
          const noidungrp = GdkCrypto.decryptAES(m.data);
          const noidungJson = JSON.parse(noidungrp);
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
          //  console.log('result', noidungJson);
          return noidungJson;
        })
      ).subscribe(
        s => {
          if (typeAlert) {
            if (s.ok) {
              this.gdkAlert.success(s.msg);
            } else {
              this.gdkAlert.error(s.msg);
            }
            this.gdkAlert.loading(false);
          }
          // console.log('res', s);
          // if (s['data']) {
          //   s['data'] = GdkUtils.queryToJson(s['data']);
          // }

          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          // console.log('erro');
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  queryData2(data: GdkReqDataSql | any, options: { typeAlert: boolean, path: string } = {
    typeAlert: false,
    path: ''
  }): Observable<GdkReqDataSqlResult | any> {


    if (options.typeAlert) {
      this.gdkAlert.loading(true, 1);
    }
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    const _token = GdkInfoPage.getToken();
    if (_token) {
      headers = headers.append('token', _token);
      // headers = new HttpHeaders( {
      //     'Content-Type': 'application/json',
      //     'token': _token
      //      }
      // );
    } else {
      return of({ok: false, msg: 'Khá»i táº¡o khÃ´ng thÃ nh cÃ´ng!'});
    }

    // console.log('req', data);
    // data = GdkUtils.parms_Convert_mongodb(data, this.translate.getDefaultLang());
    // console.log('JSON.stringify(data)', JSON.stringify(data));
    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>
      (
        this.config.urlBaseServer + (options.path || '/query'),
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'}
      ).pipe(map(
        m => {
          const noidungrp = GdkCrypto.decryptAES(m.data);
          const noidungJson = JSON.parse(noidungrp);
          if (options.typeAlert) {
            this.gdkAlert.loading(false);
          }
          //  console.log('result', noidungJson);
          return noidungJson;
        })
      ).subscribe(
        s => {
          if (options.typeAlert) {
            if (s.ok) {
              this.gdkAlert.success(s.msg);
            } else {
              this.gdkAlert.error(s.msg);
            }
            this.gdkAlert.loading(false);
          }
          // console.log('res', s);
          // if (s['data']) {
          //   s['data'] = GdkUtils.queryToJson(s['data']);
          // }

          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          // console.log('erro');
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          if (options.typeAlert) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  queryData3(data: GdkReqDataSql | any, options: { typeAlert?: boolean, desAESOnMap?: boolean, path?: string } = {
    typeAlert: false,
    path: '',
    desAESOnMap: true
  }): Observable<GdkReqDataSqlResult | any> {


    if (options.typeAlert) {
      this.gdkAlert.loading(true, 1);
    }
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    const _token = GdkInfoPage.getToken();
    if (_token) {
      headers = headers.append('token', _token);
      // headers = new HttpHeaders( {
      //     'Content-Type': 'application/json',
      //     'token': _token
      //      }
      // );
    } else {
      return of({ok: false, msg: 'Khá»i táº¡o khÃ´ng thÃ nh cÃ´ng!'});
    }

    // console.log('req', data);
    // data = GdkUtils.parms_Convert_mongodb(data, this.translate.getDefaultLang());
    // console.log('JSON.stringify(data)', JSON.stringify(data));
    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>
      (
        this.config.urlBaseServer + (options.path || '/query'),
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'}
      ).pipe(map(
        m => {
          if (options.typeAlert) {
            this.gdkAlert.loading(false);
          }
          if (options.desAESOnMap) {
            const noidungrp = GdkCrypto.decryptAES(m.data);
            return JSON.parse(noidungrp) || null;
          } else {
            return m;
          }


          //  console.log('result', noidungJson);

        })
      ).subscribe(
        s => {

          if (options.typeAlert) {
            if (s.ok) {
              this.gdkAlert.success(s.msg);
            } else {
              this.gdkAlert.error(s.msg);
            }
            this.gdkAlert.loading(false);
          }
          // console.log('res', s);
          // if (s['data']) {
          //   s['data'] = GdkUtils.queryToJson(s['data']);
          // }

          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          // console.log('erro');
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          if (options.typeAlert) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  queryDataReport(data: GdkReqReport, typeAlert: true | false = false): Observable<GdkReqDataSqlResult | any> {

    if (typeAlert) {
      this.gdkAlert.loading(true, 1);
    }
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    const _token = GdkInfoPage.getToken();
    if (_token) {
      headers = headers.append('token', _token);
      // headers = new HttpHeaders( {
      //     'Content-Type': 'application/json',
      //     'token': _token
      //      }
      // );
    } else {
      return of({ok: false, msg: 'Khá»i táº¡o khÃ´ng thÃ nh cÃ´ng!'});
    }

    // console.log('req', data);

    // data.reqDataSql = GdkUtils.parms_ReqDataSql(data.reqDataSql);

    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>
      (
        this.config.urlBaseServer + '/report',
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'}
      ).pipe(map(
        m => {
          const noidungrp = GdkCrypto.decryptAES(m.data);
          const noidungJson = JSON.parse(noidungrp);
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
          // console.log('result', noidungJson);
          return noidungJson;
        })
      ).subscribe(
        s => {
          if (typeAlert) {
            if (s.ok) {
              this.gdkAlert.success(s.msg);
            } else {
              this.gdkAlert.error(s.msg);
            }
            this.gdkAlert.loading(false);
          }
          // console.log('res-report', s);
          // if (s['data']) {
          //   s['data'] = GdkUtils.queryToJson(s['data']);
          // }

          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          //  console.log('erro');
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  queryDataReportTest(data: { reqHtml: string, reportData: any }, typeAlert: true | false = false): Observable<GdkReqDataSqlResult | any> {

    if (typeAlert) {
      this.gdkAlert.loading(true, 1);
    }
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    const _token = GdkInfoPage.getToken();
    if (_token) {
      headers = headers.append('token', _token);
      // headers = new HttpHeaders( {
      //     'Content-Type': 'application/json',
      //     'token': _token
      //      }
      // );
    } else {
      return of({ok: false, msg: 'Khá»i táº¡o khÃ´ng thÃ nh cÃ´ng!'});
    }

    // console.log('req', data);
    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>
      (
        this.config.urlBaseServer + '/testreport',
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'}
      ).pipe(map(
        m => {
          const noidungrp = GdkCrypto.decryptAES(m.data);
          const noidungJson = JSON.parse(noidungrp);
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
          //  console.log('result', noidungJson);
          return noidungJson;
        })
      ).subscribe(
        s => {
          if (typeAlert) {
            if (s.ok) {
              this.gdkAlert.success(s.msg);
            } else {
              this.gdkAlert.error(s.msg);
            }
            this.gdkAlert.loading(false);
          }
          //  console.log('res-report', s);
          // if (s['data']) {
          //   s['data'] = GdkUtils.queryToJson(s['data']);
          // }

          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          //   console.log('erro');
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  queryPublicData(data: GdkReqDataSql, typeAlert: true | false = false): Observable<GdkReqDataSqlResult | any> {

    if (typeAlert) {
      this.gdkAlert.loading(true, 1);
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    // data = GdkUtils.parms_andObject_Date_toString(data);
    data = GdkUtils.parms_Convert_mongodb(data, this.translate.getDefaultLang());
    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>
      (
        this.config.urlBaseServer + '/publicquery',
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'}
      ).pipe(map(
        m => {
          const noidungrp = GdkCrypto.decryptAES(m.data);
          const noidungJson = JSON.parse(noidungrp);
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
          // console.log('result', noidungJson);
          return noidungJson;
        })
      ).subscribe(
        s => {
          if (typeAlert) {
            if (s.ok) {
              this.gdkAlert.success(s.msg);
            } else {
              this.gdkAlert.error(s.msg);
            }
            this.gdkAlert.loading(false);
          }
          // console.log('res', s);
          // if (s['data']) {
          //   s['data'] = GdkUtils.queryToJson(s['data']);
          // }
          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          // console.log('erro');
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          if (typeAlert) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  queryPublicData2(data: GdkReqDataSql | any, options: { typeAlert?: boolean, path?: string, desAESOnMap?: boolean } = {
    typeAlert: false,
    path: '',
    desAESOnMap: true
  }): Observable<GdkReqDataSqlResult | any> {

    if (options.typeAlert) {
      this.gdkAlert.loading(true, 1);
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    // data = GdkUtils.parms_andObject_Date_toString(data);
    data = GdkUtils.parms_Convert_mongodb(data, this.translate.getDefaultLang());
    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>
      (
        this.config.urlBaseServer + (options.path || '/publicquery'),
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'}
      ).pipe(map(
        m => {
          if (options.typeAlert) {
            this.gdkAlert.loading(false);
          }
          if (options.desAESOnMap) {
            const noidungrp = GdkCrypto.decryptAES(m.data);
            return JSON.parse(noidungrp);
          } else {
            return m;
          }
        })
      ).subscribe(
        s => {
          if (options.typeAlert) {
            if (s.ok) {
              this.gdkAlert.success(s.msg);
            } else {
              this.gdkAlert.error(s.msg);
            }
            this.gdkAlert.loading(false);
          }
          // console.log('res', s);
          // if (s['data']) {
          //   s['data'] = GdkUtils.queryToJson(s['data']);
          // }
          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          // console.log('erro');
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          if (options.typeAlert) {
            this.gdkAlert.loading(false);
          }
        }
      );
    });
  }

  checkLogin(): boolean {
    const _token = GdkInfoPage.getToken();
    if (!_token) {
      return false;
    }
    return true;
  }


  login(data: GdkLogin, typeAlert: true | false = true): Observable<GdkReqDataSqlResult | any> {
    this.gdkAlert.loading(true, 1);
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    const _token = GdkInfoPage.getToken();
    if (_token) {
      headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'token': _token
        }
      );
    } else {
      headers = new HttpHeaders({
          'Content-Type': 'application/json'
        }
      );
    }

    const _data = GdkCrypto.encryptAES(JSON.stringify(data));
    //   console.log(this.config.urlBaseServer + this.config.pathLoginSV);
    return Observable.create(obs => {
      this.httpclient.post<GdkReqDataSqlResult | any>(
        this.config.urlBaseServer + '/checklogin',
        JSON.stringify({data: _data}),
        {headers: headers, responseType: 'json'})
        .pipe(
          map(m => {
            const noidungrp = GdkCrypto.decryptAES(m.data);
            const noidungJson = JSON.parse(noidungrp);
            // console.log(noidungJson);
            if (noidungJson.ok) {
              if (noidungJson.token) {
                try {
                  GdkInfoPage.setToken(noidungJson.token);
                  // console.log(noidungJson.info);
                  GdkInfoPage.setInfo(noidungJson.info);
                  if (this._gdkNav.checkIsKeyNavigation('main')) {
                    this._gdkNav.unregister('main');
                    this._gdkNav.register('main', GdkInfoPage.getMenuNav());
                    this._gdkNav.setCurrentNavigation('main');
                  }
                } catch (e) {
                  // console.log(e);
                }

              } else {
                noidungJson.ok = false;
              }

            }
            //  console.log(noidungJson);
            this.gdkAlert.loading(false);
            return noidungJson;
          })
        ).subscribe(
        s => {
          obs.next(s);
          obs.complete();
        }, err => {
          obs.error(err);
          obs.complete();
          this.gdkAlert.alert('Lá»i káº¿t dá»ch vá»¥.');
          this.gdkAlert.loading(false);
        }
      );
    });
  }


  logout(): void {
    this.gdkLogout.logoutUpdate({ok: true, url: GdkInfoPage.getLogin()});
  }

  generateID(id: string, reset: boolean = false, size: number = 5): Observable<string> {
    id = id.toLowerCase();
    return Observable.create(c => {
      if (reset) {
        this.queryPublicData({
          reqData: {
            reqid: '6032ac4f',
            parmsOb: {id: id}
          }
        }, false).subscribe(s => {
          // console.log(s);
          if (s.ok && s.data.length > 0) {
            const ma = id.toUpperCase() + (s.data[0][id] + '').padStart(size, '0');

            localStorage.setItem('trf-' + id, ma);
            c.next(ma);
            c.complete();
          } else {
            c.next(GdkUtils.generateGUID());
            c.complete();
          }
        });
      } else {
        const ma = localStorage.getItem('trf-' + id);
        if (!ma) {
          this.queryPublicData({
            reqData: {
              reqid: '6032ac4f',
              parmsOb: {id: id}
            }
          }, false).subscribe(s => {
            //  console.log(s);
            if (s.ok && s.data.length > 0) {
              const ma$ = id.toUpperCase() + (s.data[0][id] + '').padStart(size, '0');

              localStorage.setItem('trf-' + id, ma$);
              c.next(ma$);
              c.complete();
            } else {
              c.next(GdkUtils.generateGUID());
              c.complete();
            }
          });
        } else {
          c.next(ma);
          c.complete();
        }
      }

    });


  }


  getNameLang(values: { [key: string]: string } | string | number | boolean): any | string | number | boolean {
    const lang = this.translate.getDefaultLang();
    if (values) {
      const type_val = typeof values;
      if (['string', 'number', 'boolean'].includes(type_val)) {
        return values;
      } else {
        if (lang && typeof values === 'object') {
          return (values.hasOwnProperty(lang)) ? values[lang] : (values.hasOwnProperty('vi') ? values['vi'] : values);
          // return values[lang] || values['vi'] || values;
        }
      }
    }

    return values;

  }

  getDefaultLang(): string {
    return this.translate.getDefaultLang();
  }

  transKeyToString(val: string | any, option?: any): string | any {
    this.translate.get(val, option).subscribe(s => {
      val = s;
    });
    return val;
  }

}
